import { Map } from "../Types/Map";

export class I18nHelper {
    static TransList: Map<string> = new Map<string>();
    private static Loaded: boolean = false;

    constructor() {
        if (!I18nHelper.Loaded) {
            if (typeof Translation == 'undefined' || Translation == null) {
                return;
            }

            for (let trans of Translation) {
                I18nHelper.TransList.add(trans[0].charAt(0).toUpperCase() + trans[0].slice(1), trans[1]);
            }
        }
    }

    GetTranslation(key: Translations, ...args: any[]): string {
        let translation = I18nHelper.TransList.get(Translations[key]);
        return (translation || "").replace(/\{[0-9]\}/g, (substring) => args[substring.substring(1, substring.length - 1)] ?? '');
    }
}

//Always Uppercase
export enum Translations {
    Ticket,
    Tickets,
    Reserve,
    Summary,
    Checkout,
    Timings,
    QuantityDate,
    Error,
    TicketVerification,
    ReservationManagement,
    DateTimeReservation,
    Confirmation,
    Next,
    CountAvailable,
    AreYouSure,
    OneWayReservation,
    ConfirmReservation,
    DeleteReservationPopup,
    DeleteConfirmationPopup,
    NotValidSerialNumber,
    ValueMissing,
    CartAdd,
    OnlyNumbers,
    NotValidWtp,
    DrpZneDefaultMessage,
    Various,
    People,
    DrpZneFallbackMessage,
    Location,
    DrpZneFallbackText,
    DrpZneFileTooBig,
    DrpZneInvalidFileType,
    SlotsN,
    WTPNumberNotFound,
    LevelsAll,
    DrpZneResponseError,
    DrpZneCancelUpload,
    DrpZneCancelUploadConfirmation,
    DrpZneRemoveFile,
    DrpZneMaxFilesExceeded,
    Success,
    FeldErforderlich,
    AddressPleaseAdd,
    BookNow,
    PasswordNotValid,
    PasswordUnequal,
    SelectTicket,
    AmountAndDesign,
    Personalize,
    ValidationMail,
    From,
    To,
    Message,
    PleaseSelectGiftCardTemplate,
    Cancel,
    SelectCard,
    SlotsAvailable,
    DeviceNotSupported,
    ServerErrorText1,
    ServerErrorText2,
    Oops,
    Ok,
    OutOfX,
    VoucherCurrentlyNotRedeemable,
    VoucherNotPartlyRedeemable,
    CartCart,
    ProductSelectionRequired,
    WtpPleaseInsert,
    ShowXResults,
    LegitimationCheckError,
    SelectDate,
    Continue,
    SelectAtLeastOneTicket,
    State,
    LoginCredentialsWrong,
    LoginSuccess,
    AddCoverPoster,
    AddCoverForVideo,
    YesPlease,
    NoThanks,
    Whoops,
    MaxQuantity,
    MinQuantity,
    MaximumFileSize,
    AcceptableFilesExtention,
    ConfirmationEmailSent,
    Free,
    SoldOut,
    MyTicketsInfoBarCode,
    MyTicketsInfoVoucher,
    MyTicketsInfoBLE,
    LinkCopiedToClipboard,
    WrongDay,
    WrongSelectedDay,
    AdminClose,
    Rentals,
    MandatoryRentalDataMissing,
    RentalNoPersonSelected,
    OneRISKProcessIsRequiredBeforeProceed,
    OneRISKNecessityMessage,
    Warning,
    WaiverSaveFail,
    WaiverIsCompleted,
    BodyLoggingEnabledAlert,
    RentalAdditionalOptions,
    RentalYouCanSkipThisPart,
    RentalNoProperties,
    ProceedToCheckout,
    QuantityTicket,
    SelectCategoryFirst,
    SelectDateFirst,
    SelectTicketFirst,
    TicketsX,
    SelectACategory,
    SelectAStartingDate,
    NumberOfTickets,
    WaiverModal,
    ResetSelection,
    ConfirmDelete,
    LinkedArticleWaiverCheckError,
    LinkedArticleWaiverDelete,
    LinkedArticleWaiverAlreadyExists,
    ShowDetails,
    Save,
    Edit,
    AdminCreateNewComplexPackage,
    CurrentlyUsed,
    SureToDelete,
    AdminFilter,
    StartShopping,
    ReservationExpired,
    SVCodeInvalidSyntax,
    SVCodeEmpty,
    AmountTotal,
    SVCodeAtWithThisFormat,
    MaintenanceActModeDesc,
    MaintenanceModeActOffSeasonDesc,
    MaintenanceModeDeActDesc,
    MaintenanceModeDeActOffSeasonDesc,
    Voucher,
    RequiredData,
    SelectAll,
    ShoppingCartCapitals,
}
